import React from 'react';
import {Navigate, Route, Routes} from "react-router-dom";
import Layout from "pages/layout";
import Unauthorized from "pages/unAuthorized";
import RequireAuth from "components/requireAuth";
import Dashboard from "pages/dashboard";
import Profil from "pages/profil/profil";
import MyAccountContent
    from "pages/profil/content/myAccount.content";
import LegalInformationContent
    from "pages/profil/content/legalInformation.content";
import ModesOfPaymentContent
    from "pages/profil/content/modesOfPayment.content";
import BonusesCompensationContent
    from "pages/profil/content/bonusesCompensation.content";
import PaymentsTermsContent
    from "pages/profil/content/paymentsTerms.content";
import Mission from "pages/missions/mission";
import EndContent from "pages/missions/content/end.content";
import InProgressContent
    from "pages/missions/content/inProgress.content";
import ComingSoonContent
    from "pages/missions/content/comingSoon.content";
import Contract from "pages/contract/contract";
import SignedContent
    from "pages/files/contract/content/signed.content";
import ToBeSignedContent
    from "pages/files/contract/content/toBeSigned.content";
import Invoice from "pages/invoice/invoice";
import SettleContent
    from "pages/files/invoices/content/settle.content";
import ToBeSetContent
    from "pages/files/invoices/content/toBeSet.content";
import AdminCompany from "pages/admin";
import CreateOfMission from "pages/createOfMission";
import Activity from "pages/activity";
import TimeSheet from "pages/timeSheet/timeSheet";
import CheckedContent
    from "pages/timeSheet/content/checked.content";
import ToBeCheckedContent
    from "pages/timeSheet/content/toBeChecked.content";
import LitigationContent
    from "pages/timeSheet/content/litigation.content";
import PersonalInformation
    from "pages/personalInformation/personalInformation";
import MyAccountPersonalContent
    from "pages/personalInformation/content/myAccountPersonal.content";
import ParamsContent
    from "pages/personalInformation/content/params.content";
import MissionFiche from "pages/missionFiche";
import InvoiceFiche from "pages/invoiceFiche";
import ContractFiche from "pages/contractFiche";
import LayoutCompany from "components/layout";
import PdfView from "pages/pdfView";
import JobPostTemplates from "pages/jobPostTemplates";
import CreateOfTemplate from "pages/jobPostTemplates/createOfTemplate";


const Index = () => {
    // {/*'200':'Observateur',*/}
    // {/*'205':'Manageur',*/}
    // {/*'210':'Responsable',*/}
    // {/*'215':'Directeur',*/}
    // {/*'220':'Superviseur'*/}
    // {/*'225':'Administrateur'*/}
    const ROLES = {
        'interim': '100',
        'observateur': '200',
        'manageur': '205',
        'responsable': '210',
        'directeur': '215',
        'superviseur': '220',
        'admin': '225'
    }
    return (
        <>
            <Routes>
                <Route path='/' element={<Layout/>}>
                    <Route path='/entreprise' element={<LayoutCompany/>}/>
                    <Route element={<RequireAuth allowedRoles={[ROLES.observateur, ROLES.manageur, ROLES.responsable, ROLES.directeur, ROLES.admin, ROLES.superviseur]}/>}>
                        <Route path='dashboard'
                               allowedRoles={[ROLES.observateur, ROLES.manageur, ROLES.responsable, ROLES.directeur, ROLES.admin]}
                               element={<Dashboard/>}/>
                        <Route element={<RequireAuth
                            allowedRoles={[ROLES.directeur, ROLES.admin]}/>}>
                            <Route path='profil' element={<Profil/>}>
                                <Route index element={<Navigate to="myAccountCompany" replace />} />
                                <Route path='myAccountCompany'
                                       element={<MyAccountContent/>}/>
                                <Route path='legalInformation' element={
                                    <LegalInformationContent/>}/>
                                <Route path='modesOfPayments' element={
                                    <ModesOfPaymentContent/>}/>
                                <Route path='bonusesAndCompensation'
                                       element={
                                           <BonusesCompensationContent/>}/>
                                <Route path='paymentsTerms'
                                       element={<PaymentsTermsContent/>}/>
                            </Route>
                        </Route>
                        <Route path={'missions'}
                               allowedRoles={[ROLES.observateur, ROLES.responsable, ROLES.directeur, ROLES.superviseur, ROLES.admin]}
                               element={<Mission/>}>
                            <Route index element={<Navigate to="inProgress" replace />} />
                            <Route path={'end'}
                                   element={<EndContent/>}/>
                            <Route path={'inProgress'}
                                   element={<InProgressContent/>}/>
                            <Route path={'comingSoon'}
                                   element={<ComingSoonContent/>}/>
                        </Route>
                        <Route path={'mission/:id'}
                               allowedRoles={[ROLES.observateur, ROLES.responsable, ROLES.directeur, ROLES.superviseur, ROLES.admin]}
                               element={<MissionFiche/>}
                        />

                        <Route path={'contract'}
                               allowedRoles={[ROLES.observateur, ROLES.responsable, ROLES.directeur, ROLES.admin]}
                               element={<Contract/>}
                        >
                            <Route index element={<Navigate to="toBeSigned" replace />} />
                            <Route path={'signed'}
                                   element={<SignedContent/>}/>
                            <Route path={'toBeSigned'} element={
                                <ToBeSignedContent/>}/>
                        </Route>
                        <Route path={'contract/detail'}
                               allowedRoles={[ROLES.observateur, ROLES.responsable, ROLES.directeur, ROLES.admin]}
                               element={<ContractFiche/>}
                        />
                        <Route path={'invoice'}
                               allowedRoles={[ROLES.observateur, ROLES.responsable, ROLES.directeur, ROLES.admin]}
                               element={<Invoice/>}
                        >
                            <Route index element={<Navigate to="toBeSet" replace />} />
                            <Route path={'settle'}
                                   element={<SettleContent/>}/>
                            <Route path={'toBeSet'}
                                   element={<ToBeSetContent/>}/>
                        </Route>
                        <Route path={'invoice/detail'}
                               allowedRoles={[ROLES.observateur, ROLES.responsable, ROLES.directeur, ROLES.admin]}
                               element={<InvoiceFiche/>}
                        />
                        <Route path={'timeSheet'}
                               allowedRoles={[ROLES.observateur, ROLES.manageur, ROLES.responsable, ROLES.directeur, ROLES.superviseur, ROLES.admin]}
                               element={<TimeSheet/>}
                        >
                            <Route index element={<Navigate to="toBeChecked" replace />} />
                            <Route path={'checked'}
                                   element={<CheckedContent/>}/>
                            <Route path={'toBeChecked'}
                                   element={<ToBeCheckedContent/>}/>
                            <Route path={'litigation'}
                                   element={<LitigationContent/>}/>
                        </Route>
                        <Route path={'personalInformations'}
                               allowedRoles={[ROLES.observateur, ROLES.manageur, ROLES.responsable, ROLES.directeur, ROLES.admin]}
                               element={<PersonalInformation/>}
                        >
                            <Route path={'myPersonalAccount'}
                                   element={
                                       <MyAccountPersonalContent/>}/>
                            <Route path={'params'}
                                   element={<ParamsContent/>}/>
                        </Route>
                        <Route element={<RequireAuth
                            allowedRoles={[ROLES.admin]}/>}
                        >
                            <Route path={'adminCompany'}
                                   element={<AdminCompany/>}/>
                        </Route>
                        <Route element={<RequireAuth
                            allowedRoles={[ROLES.responsable, ROLES.directeur, ROLES.superviseur, ROLES.admin]}/>}
                        >
                            <Route path={'createOfMission'}
                                   element={<CreateOfMission/>}/>
                            <Route path={'jobPostTemplates'}
                                   element={<JobPostTemplates/>}/>
                            <Route path={'jobPostTemplates/create'}
                                   element={<CreateOfTemplate mode={'create'}/>}/>
                            <Route path={'jobPostTemplates/edit/:id'}
                                   element={<CreateOfTemplate mode={'edit'}/>}/>
                        </Route>
                        <Route path={'activityCompany'}
                               allowedRoles={[ROLES.observateur, ROLES.responsable, ROLES.directeur, ROLES.admin]}
                               element={<Activity/>}
                        />
                    </Route>
                    <Route path='pdfView' element={<PdfView/>}/>
                    <Route path={'*'} element={<Unauthorized/>}/>
                    <Route path={""} element={<Navigate to="/dashboard"/>}/>
                    <Route path={"*"} element={<Navigate to="/dashboard"/>}/>
                </Route>
            </Routes>
        </>
    )
        ;
};

export default Index;